var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpgradeAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0693359,
    y: 0.383789,
    width: 11.8605,
    height: 11.9767,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1076_4696",
    transform: "translate(0 0.00485435) scale(0.01 0.00990291)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1076_4696",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAADMUlEQVR4nO3XTU4UQRjG8aeMwAmUxBOYIAQjGi7CFbgCLDFhAVfwCKIr9QomRjEEOIMxLHSNQ/K4mJ446rw9XV1f/fH8EjYk3VVdb/40DYiIiIiIiIiIiIiIiIiIiIiIiIhId5F8QPI1yXckH5Xez6iR3CN5wz9+kNwvva/RmavColpyWVCFRbWk1KAK1ZKLRxWqJaWAKiyqpS2GV2FRLT4YvwqLalmG6aqwqJZFGFbFT5L7DBumapkJPMj38wdJ8iHJs5b3GnctjFBFzb1Vi4/AA/uripo1VMsyTFhFzZqqZZHAg2lURc3aqmWGBaqo2cu4awk8gKAqavY0vlrYoSpq9jiOWgIf9C3Jdc/11kgeVz9rnteuV2u2cUNyz+90MmKZ/6C2SH6du881yect7jOsWgIfyPtdQXKF5AHJ2wX3m5A8oX8t/X+3sBtVWMZVS+DGY1dhGX4t7HYVluHWQvKo5QZzVWEpUcuR3+m2QP+BlKrCkrMW74Hc873A0wcAG865V00vYFUFgM8AnibY0waAj/SsxTl3BuAJgDcJ9tQemxXStSosqWvpRCHfADz2rGKV5DGAc/hXMQHwsvqZeF47q+WY5GrTi6paNjF91rK4vJBrz/uFVHFJ8tncvTZJfml5L+9aqmvqdKKQRhj2rrgDcApgxzl3Pvulc+4KwC6AQwC/PO/Z6t0SW5GBkNwC8AnACYDGfyoqVwB2nXOHzrn/Dt05d+ecOwWwg+mfQB/3ARwAOPetJZasA0lRhaWvtWQbSMoqLH2sJflAclZh6VMtSQdSogpLX2pJMpAuVGHpUy2NcPl3yHdOvw/auCC5nfFZtqs127isnrVOJ75D1jH9ivUxq+KFc+4i/pYWq9baQbtaNjF91qiKfRjOifqu8BX4bomu5ECSvit8Bb5boik1kKJVWLpQS+6BdKoKS8lacg6kk1VYStWSYyC9qMKSu5bUA+lVFZactaQaSK+rsOSoJcVABlGFJXUtMQcyyCosqWqJNZBBV2FJUUvoQEZVhSVmLSEDGWUVlli1tBnIBKrC9E8tt8kXJLmSfJGB0FmJiIiIiIiIiIiIiIiIiIjE8xsKgSlCoVZy1wAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgradeAccount);
export default __webpack_public_path__ + "static/media/upgrade-account.6bc20ce53cd873c683d6f302ff6926c7.svg";
export { ForwardRef as ReactComponent };